import styled, { css } from 'styled-components';
import { Button, Layout } from 'antd';
import { Link } from 'react-router-dom';

export const Sider = styled(Layout.Sider)`
  position: fixed;
  overflow: visible;
  right: 0;
  z-index: 5;
  min-height: 100vh;
  max-height: 100vh;

  /* Column layout so the profile footer can pin to the bottom while the menu
     scrolls. AntD wraps sider content in this element, so it has to be the
     flex container rather than the Sider itself. */
  & .ant-layout-sider-children {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  color: ${(props) => props.theme.colors.text.secondary};

  @media only screen and ${(props) => props.theme.media.md} {
    right: unset;
    left: 0;
  }

  @media only screen and ${(props) => props.theme.media.xl} {
    position: unset;
  }
`;

export const CollapseButton = styled(Button)<{ $isCollapsed: boolean }>`
  background: ${(props) => props.theme.colors.main.primary};
  transition: all 0.2s ease;
  position: absolute;
  right: 0.5rem;

  ${(props) =>
    props.$isCollapsed &&
    css`
      right: -1rem;
    `}

  color: ${(props) => props.theme.colors.text.secondary};

  &:hover {
    color: ${(props) => props.theme.colors.text.secondary};
    background: ${(props) => props.theme.colors.main.primary};
  }

  &:focus {
    color: ${(props) => props.theme.colors.text.secondary};
    background: ${(props) => props.theme.colors.main.primary};
  }
`;

export const SiderContent = styled.div`
  flex: 1 1 auto;
  /* min-height:0 is what actually lets a flex child scroll rather than
     overflowing its parent. */
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
`;

/** Profile control pinned to the bottom of the sider. */
export const SiderFooter = styled.div`
  flex: 0 0 auto;
  margin-top: auto;
  padding: 0.75rem;
  /* The sider is dark in BOTH themes (a purple-grey gradient in dark, a blue
     one in light), so these are white-alpha rather than the ink-derived
     --soft-panel-* tokens, which would go dark-on-blue in light mode. */
  border-top: 1px solid rgba(255, 255, 255, 0.12);

  /* The dropdown trigger is a pill in the header; in the sider it should read
     as a full-width row instead. */
  .ant-dropdown-trigger {
    width: 100%;
    border-radius: 8px;
    margin: 0;
    padding: 0.375rem 0.5rem;
    flex-wrap: nowrap;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }

  h6 {
    margin: 0;
    max-width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const SiderLogoLink = styled(Link)`
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;
`;

export const SiderLogoDiv = styled.div`
  height: ${(props) => props.theme.mobileLayout.headerHeight};
  padding: ${(props) => props.theme.mobileLayout.headerPadding};
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media only screen and ${(props) => props.theme.media.md} {
    height: ${(props) => props.theme.desktopLayout.headerHeight};
    padding-top: ${(props) => props.theme.desktopLayout.paddingVertical};
    padding-bottom: ${(props) => props.theme.desktopLayout.paddingVertical};
  }
`;

export const BrandSpan = styled.span`
  margin: 0 1rem;
  font-weight: 700;
  font-size: 1.125rem;
  color: ${(props) => props.theme.commonColors.white};
`;
